import React, { useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import TableBody from './tableBody';
import TableHead from './tableHead';
import ConfirmModal from '../../../../components/Modal/Confirm';
import ConfirmTemplates from '../ConfirmTemplates';

import { submitMassAction, prepareConfirmBtnsText } from '../../helpers';
import useShiftSelected from '../../../../utils/hooks/useShiftSelected';

const TableTickets = ({
  isLoading,
  tickets,
  accessMassActions,
  statuses,
  values,
  setValues,
  config,
  staff,
  staffFetching,
  filters,
  onSelectStatuses,
}) => {
  const dispatch = useDispatch();

  const ticketsIds = useMemo(() => tickets?.filter((t) => t.status !== 4).map((t) => t.id), [tickets]);

  const massFetching = useSelector((state) => state.tickets.massFetching);
  // const [isAssignAction, setIsAssign] = useState(false);

  const [isOpenConfirm, setIsOpen] = useState(false);
  const [confirmValues, setConfirmValues] = useState({
    key: null,
    title: '',
  });

  const toggleConfirm = () => {
    // if (isOpenConfirm) setIsAssign(false);
    setIsOpen(!isOpenConfirm);
  };

  const onChange = useShiftSelected(ticketsIds, values);

  const onChangeCheck = (event, ticket) => {
    const nextValue = onChange(event, ticket.id);

    setValues(nextValue);
  };

  const onChangeCheckAll = (e) => {
    if (e.target.value === 'checkAll' && e.target.checked) {
      return setValues([...tickets.filter((item) => item.status !== 4).map((item) => item.id)]);
    }
    if (e.target.value === 'checkAll' && !e.target.checked) {
      return setValues([]);
    }
  };

  const handleSelect = (key, title) => {
    setConfirmValues({
      key,
      title,
    });
    // if (title === 'Assign') setIsAssign(true);
    toggleConfirm();
  };

  const onSubmitConfirm = async () => {
    try {
      await dispatch(submitMassAction({ ...confirmValues, values }));
      setValues([]);
      toggleConfirm();
    } catch (error) {
      setValues([]);
      toggleConfirm();
    }
  };

  return (
    <>
      <ConfirmModal
        toggle={toggleConfirm}
        isOpen={isOpenConfirm}
        onConfirm={onSubmitConfirm}
        fetching={massFetching}
        title={<ConfirmTemplates.Title actionKey={confirmValues.key} {...confirmValues} />}
        description={<ConfirmTemplates.Body selectedCount={values?.length} actionKey={confirmValues.key} {...confirmValues} />}
        {...prepareConfirmBtnsText(confirmValues)}
      />

      <Table>
        <TableHead
          pageFilters={filters}
          values={values}
          staff={staff}
          staffFetching={staffFetching}
          statuses={statuses}
          config={config}
          handleSelect={handleSelect}
          onChangeCheck={onChangeCheckAll}
          accessMassActions={accessMassActions}
          onSelectStatuses={onSelectStatuses}
        />
        <TableBody isLoading={isLoading} tickets={tickets} values={values} config={config} onChangeCheck={onChangeCheck} />
      </Table>
    </>
  );
};

TableTickets.propTypes = {
  isLoading: PropTypes.bool,
  tickets: PropTypes.array,
  accessMassActions: PropTypes.array,
  statuses: PropTypes.array,
  values: PropTypes.array,
  setValues: PropTypes.func,
  config: PropTypes.object,
  staff: PropTypes.array,
  staffFetching: PropTypes.bool,
  filters: PropTypes.object,
  onSelectStatuses: PropTypes.func,
};

export default TableTickets;
